// Author liang gang qiang
// Date 2021-10-22 14:57:43

class MintalMesMstEnergy {
constructor({
        id = null,
        code = '',
        name = '',
        type = '',
        unit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.type = type;
    this.unit = unit;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesMstEnergy();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.type',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '水' },
                            { value: '2', text: '电' },
                            { value: '3', text: '气' }
            ]
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstEnergy.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    typeFilter : '',
    unitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.mst.mintalMesMstEnergy.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.mst.mintalMesMstEnergy.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.mintal.mst.mintalMesMstEnergy.filter.type',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '水' },
                { value: '2', text: '电' },
                { value: '3', text: '气' }
            ]
        }
        },
        {
        key: 'unitFilter',
        label: 'label.mintal.mst.mintalMesMstEnergy.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstEnergy.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstEnergy.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstEnergy.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '水' },
                { value: '2', text: '电' },
                { value: '3', text: '气' }
            ]
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.mst.mintalMesMstEnergy.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstEnergy.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesMstEnergy, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
